import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/useAuthStore'
import { useI18n } from '../i18n'

export function AuthArea() {
  const { t, locale, setLocale } = useI18n()
  const user = useAuthStore((s) => s.user)
  const logout = useAuthStore((s) => s.logout)
  const navigate = useNavigate()

  return (
    <div className="flex items-center gap-3">
      <button
        onClick={() => setLocale(locale === 'de' ? 'en' : 'de')}
        className="rounded-md bg-surface-lighter px-2 py-1 text-xs text-text-muted uppercase hover:text-text transition-colors"
      >
        {locale === 'de' ? 'EN' : 'DE'}
      </button>

      {user ? (
        <>
          <button
            onClick={() => navigate('/account')}
            className="rounded-md bg-surface-lighter px-3 py-1.5 text-xs text-text-muted hover:text-text transition-colors"
          >
            {user.username}
          </button>
          <button
            onClick={async () => {
              await logout()
              navigate('/logout')
            }}
            className="rounded-md bg-surface-lighter px-3 py-1.5 text-xs text-text-muted hover:text-text transition-colors"
          >
            {t('auth.logout')}
          </button>
        </>
      ) : (
        <button
          onClick={() => navigate('/login')}
          className="rounded-md bg-primary px-4 py-1.5 text-sm text-white hover:bg-primary-dark transition-colors"
        >
          {t('auth.login')}
        </button>
      )}
    </div>
  )
}
